<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="待补货单"> </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:otherOperations>
        <div style="display: flex; align-items: center">
          <el-button
            size="small"
            type="primary"
            @click="generateReplenishmentOrder"
            >生成补货单</el-button
          >
        </div>
      </template>
      <template v-slot:need_num="row">
        <div style="display: flex; align-items: center">
          <el-input
            v-model="row.row.need_num"
            placeholder=""
            size="small"
            style="width: 80px"
          ></el-input>
          <span style="margin-left: 8px; color: #606266; font-size: 12px">
            {{ getPackageCount(row.row) }}
          </span>
        </div>
      </template>
      <template v-slot:is_below_safe_stock="row">
        <el-tag :type="row.row.is_below_safe_stock ? 'danger' : 'success'" size="small">
          {{ row.row.is_below_safe_stock ? '是' : '否' }}
        </el-tag>
      </template>
      <template v-slot:suppliernum="row">
        <el-link @click="viewSuppliers(row.row)" type="primary"
          >{{ row.row.suppliernum }}家</el-link
        >
      </template>
    </basicList>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="1200px"
      custom-class="dialogCenter"
      @close="close"
    >
      <basicList :config="detailsConfiguration"> </basicList>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import {
  itemClassGetList,
  getshoplist,
  supplierGetList,
} from "@/api/basicConfiguration";
import {
  getListSupplier,
  getSupplierList,
} from "@/api/pendingReplenishmentOrder";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "pendingReplenishmentOrder",
  data() {
    return {
      supplierlist: [],
      shopId: null,
      detailsConfiguration: {
        loading: false,
        height: "calc(100vh - 350px)",
        search: false,
        data: [],
        column: [
          {
            label: "供应商名称",
            prop: "supplier_name",
          },
          {
            label: "最近供货价",
            prop: "last_purchase_price",
            isMoney: true,
          },
          {
            label: "最近采购价",
            prop: "avg_price",
            isMoney: true,
          },
          {
            label: "差价",
            prop: "diff_price",
            isMoney: true,
          },
          {
            label: "采购次数",
            prop: "purchase_count",
            width: 100,
          },
          {
            label: "供货级别",
            prop: "level",
          },
          {
            label: "上次供货天数",
            prop: "last_supply_days",
          },
        ],
        isPage: false,
        operation: false,
        total: 0,
        searchParameters: {},
      },
      // 列表组件参数
      basicListconfig: {
        check: true,
        loading: false,
        height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "指定供应商",
            type: "select",
            options: [],
            key: "supplier_id",
            filterable: true,
            clearable: true,
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        column: [
          {
            label: "门店",
            prop: "shopname",
            width: 150,
          },
          {
            label: "品名",
            prop: "name",
            width: 300,
          },
          {
            label: "当前库存",
            prop: "num",
            width: 100,
          },
          {
            label: "目标库存",
            prop: "item_stock_target",
            width: 100,
          },
          {
            label: "补货量",
            prop: "need_num",
            slot: true,
            width: 180,
          },{
            label: "箱规",
            prop: "in_package_num",
            width: 100,
          },
          {
            label: "最新采购价",
            prop: "price_new",
            width: 150,
          },
          {
            label: "低于安全库存",
            prop: "is_below_safe_stock",
            slot: true,
            width: 150,
          },
          {
            label: "供应商",
            prop: "suppliernum",
            slot: true,
            width: 200,
          },
        ],
        isPage: true,
        operation: false,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      title: "",
      visible: false,
      storeList: [],
      selectedData: [],
    };
  },
  created() {
    // 设置行样式类名函数
    this.basicListconfig.rowClassName = this.tableRowClassName;
    
    this.getDataSource().then((res) => {
      // 有主门店直接查询主门店下数据;
      if (this.$store.getters.userInfo.shopId) {
        // 搜索框赋值
        this.basicListconfig.search.map((item) => {
          if (item.key == "shop_id") {
            item.value = this.$store.getters.userInfo.shopId;
          }
          return item;
        });
        // 没有主门店手动选择门店可查看;
        this.basicListconfig.searchParameters.shop_id = Number(
          this.$store.getters.userInfo.shopId
        );
        this.getlist();
      } else {
        this.$message.error("本账号没有主门店，需要手动选择一个门店！");
      }
    });
  },
  methods: {
    // 计算箱数量显示
    getPackageCount(row) {
      const needNum = row.need_num || 0;
      const packageNum = row.in_package_num || 1;
      const boxCount = Math.floor(needNum / packageNum);
      return `（${boxCount}箱）`;
    },
    // 表格行样式
    tableRowClassName({ row, rowIndex }) {
      if (row.is_below_safe_stock) {
        return 'warning-row';
      }
      return '';
    },
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    generateReplenishmentOrder() {
      // 如果没有选中则默认全部
      let exportData = [];
      if (this.selectedData.length == 0) {
        exportData = this.basicListconfig.data;
        if (exportData.length == 0) {
          this.$message.error("没有可导出的数据！");
          return;
        }
      } else {
        exportData = this.selectedData;
      }
      
      // 导出Excel格式（使用HTML表格方式）
      const headers = [
        "序号",
        "编码",
        "品名",
        "数量",
        "单位",
      ];
      
      // 生成HTML表格
      let html = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">';
      html += '<head><meta charset="utf-8">';
      html += '<style>';
      html += 'table {border-collapse: collapse; width: auto;}';
      html += 'th {border: 2px solid #000; padding: 20px 15px; text-align: center; font-size: 16px; font-weight: bold; background-color: #f0f0f0;}';
      html += 'td {border: 1px solid #000; padding: 18px 15px; text-align: center; font-size: 14px; height: 50px;}';
      html += 'td:first-child {width: 60px;}';
      html += 'td:nth-child(2) {text-align: left; width: 300px; mso-number-format:"@";}';
      html += 'td:nth-child(3) {width: 80px;}';
      html += 'td:nth-child(4) {width: 60px;}';
      html += '</style>';
      html += '</head>';
      html += '<body><table>';
      
      // 添加表头
      html += '<thead><tr>';
      headers.forEach(header => {
        html += '<th>' + header + '</th>';
      });
      html += '</tr></thead>';
      
      // 添加数据行
      html += '<tbody>';
      exportData.forEach((row, index) => {
        html += '<tr>';
        // 序号
        html += '<td>' + (index + 1) + '</td>';
        // 编码
        html += "<td x:str style='mso-number-format:\"@\"'>" + (row.item_number ? (String(row.item_number)) : "") + "</td>";
        // 品名
        html += '<td>' + (row.name || "") + '</td>';
        // 数量（补货量/件内数）
        let needNum = row.need_num || 0;
        let packageNum = row.in_package_num || 1;
        let quantity = Math.ceil(needNum / packageNum);
        html += '<td>' + quantity + '</td>';
        // 单位
        html += '<td>件</td>';
        html += '</tr>';
      });
      html += '</tbody>';
      html += '</table></body></html>';
      
      // 创建下载链接
      const blob = new Blob(["\ufeff" + html], {
        type: "application/vnd.ms-excel;charset=utf-8"
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      
      link.setAttribute("href", url);
      link.setAttribute("download", "补货单_" + new Date().getTime() + ".xls");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      // 同时复制文本到剪贴板
      this.copyTextToClipboard(exportData);
      
      this.$message.success("补货单生成成功，文本已复制到剪贴板！");
    },
    // 复制文本到剪贴板
    copyTextToClipboard(data) {
      let textContent = "";
      
      data.forEach((row) => {
        let name = row.name || "";
        let needNum = row.need_num || 0;
        let packageNum = row.in_package_num || 1;
        let quantity = Math.ceil(needNum / packageNum);
        
        textContent += name + "*" + quantity + "件\n";
      });
      
      textContent += "麻烦帮忙安排一下";
      
      // 复制到剪贴板
      if (navigator.clipboard && navigator.clipboard.writeText) {
        // 现代浏览器方法
        navigator.clipboard.writeText(textContent).then(() => {
          console.log("文本已复制到剪贴板");
        }).catch((err) => {
          console.error("复制失败:", err);
          this.fallbackCopyTextToClipboard(textContent);
        });
      } else {
        // 兼容旧浏览器
        this.fallbackCopyTextToClipboard(textContent);
      }
    },
    // 兼容旧浏览器的复制方法
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          console.log("文本已复制到剪贴板（兼容模式）");
        } else {
          console.error("复制失败");
        }
      } catch (err) {
        console.error("复制异常:", err);
      }
      
      document.body.removeChild(textArea);
    },
    // 查看供应商
    viewSuppliers(row) {
      this.title = "品名:" + row.name;
      this.visible = true;
      getSupplierList({ item_id: row.item_id }).then((res) => {
        this.detailsConfiguration.data = res.data.items.map((item) => {
          item.avg_price = res.data.item_info.avg_price;
          item.diff_price =
            item.last_purchase_price - res.data.item_info.avg_price;
          return item;
        });
      });
    },
    close() {
      this.visible = false;
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      localStorage.setItem("search", JSON.stringify(data));
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      getListSupplier(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 200) {
          this.basicListconfig.loading = false;
          const obj = this.storeList.find(
            (item) =>
              item.value == this.basicListconfig.searchParameters.shop_id
          );
          this.basicListconfig.data = res.data.data.map((item) => {
            item.shopname = obj.label;
            return item;
          });
          this.basicListconfig.total = res.data.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    async getDataSource() {
      const res = await getshoplist({
        status: 0,
        comp_id: JSON.parse(getRoles()).comp_id,
      });
      if (res.code == 1) {
        this.basicListconfig.search.map((item) => {
          if (item.key == "shop_id") {
            item.options = this.storeList = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });
          }
          return item;
        });
      } else {
        this.$message.error(res.msg);
      }
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      supplierGetList({
        limit: 10000,
        comp_id: this.$store.getters.userInfo.compId,
        is_showAll: 1,
        user_id: this.$store.getters.userInfo.userId,
      }).then((res) => {
        console.log("供应商数据返回：", res);
        if (res.code == 1 || res.code == 200) {
          // 兼容不同的返回code值
          const supplierData = res.data || [];
          this.supplierlist = supplierData.map((item) => {
            return {
              label: item.id + "-" + item.nick_name,
              value: item.id,
            };
          });
          
          console.log("供应商列表：", this.supplierlist);
          
          // 将供应商列表添加到筛选条件中
          this.basicListconfig.search.forEach((item) => {
            if (item.key == "supplier_id") {
              item.options = this.supplierlist;
            }
          });
          
          // 强制更新视图
          this.$forceUpdate();
        } else {
          console.error("获取供应商失败，返回code:", res.code);
          this.$message.error(res.msg || res.data.msg || "获取供应商数据源失败！");
        }
      }).catch((error) => {
        console.error("获取供应商异常：", error);
        this.$message.error("获取供应商数据源异常！");
      });
    },
  },
};
</script>

<style>
.warning-row {
  background-color: #fef0f0 !important;
}
.warning-row:hover {
  background-color: #fde2e2 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pendingReplenishmentOrder/index.vue